import Files from "./FilesContainer";

export default Files;
